import React from "react";
import { Switch, Route, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx';
import { ObavijestiPoker } from '../../Components/Layout/ObavijestiPoker.jsx';

import { PokerRakebackBody } from '../../Components/Poker/Bonuses/PokerRakebackBody.jsx';
import { PokerReloadBody } from '../../Components/Poker/Bonuses/PokerReloadBody.jsx';
import { FlopUtrkaBody } from '../../Components/Poker/Bonuses/FlopUtrkaBody.jsx';
import { BonusIzazoviBody } from '../../Components/Poker/Bonuses/BonusIzazoviBody.jsx';
import { SsoplBody } from '../../Components/Poker/Bonuses/SsoplBody.jsx';
import { BonusPobjednici } from '../../Components/Layout/BonusPobjednici.jsx';
import { PrventsvoHrvatskeBody } from '../../Components/Poker/Bonuses/PrventsvoHrvatskeBody.jsx';
import { TurnirPrvaka } from "../../Components/Poker/Bonuses/TurnirPrvaka.jsx";
import { CashLiga } from "../../Components/Poker/Bonuses/CashLiga.jsx";

export class PokerBonuses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bonusi: [
                {
                    sifra: 'prvenstvo-hrvatske', naziv: 'SuperPoker Proljetno Prvenstvo', naziv2: 'Osvoji poker putovanje u Bratislavu! ✈️♠️', bannerUrl: 'content/images/poker/bonusi/ProljetnoPrvenstvo/cover-bankroll-booster.jpg',
                    opisKratki: 'Ovog proljeća SuperPoker ponovno donosi veliku akciju uz SuperPoker Prvenstvo, gdje najbolji igrači osvajaju ulaznice za Main Event u Bratislavi.',
                    opis: `<div class="poker-prvenstvo-hrvatske-container">
                                <div>
                                    <h2 class="poker-sub-title">Počinje SuperPoker Proljetno Prvenstvo</h2>

                                    <p>
                                        Pridruži se najvećem proljetnom poker događaju! 🌸
                                    </p>
                                    <p>
                                        Ovog proljeća SuperPoker ponovno donosi veliku akciju uz SuperPoker Proljetno Prvenstvo, gdje najbolji igrači osvajaju ulaznice za Main Event u Bratislavi.
                                    </p>
                                    <p>
                                        👇 Provjeri detalje nagrada i raspored turnira u nastavku 👇
                                    </p>
                                    <div class="text-center ">
                                        <br>
                                        <a class="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href="https://cdn.supersport.hr/Casino/Poker/Pravila/SuperPoker_ProljetnoPrvenstvo_2026.pdf?v=2"><span>Pravila igre</span>
                                    <span class="icon ico-expand-outline"></span>
                                        </a>
                                    </div>`,
                    body: <PrventsvoHrvatskeBody sifra='prvenstvo-hrvatske' />, rezultati: null, active: true
                },
                {
                    sifra: 'cash-liga', naziv: 'Cash Liga', naziv2: 'Cash Liga', bannerUrl: 'content/images/poker/turniri/cover-cash-liga.jpg',
                    opisKratki: 'Počinje nova SuperPoker Cash Liga',
                    opis: `<div class="poker-prvenstvo-hrvatske-container">
                            <div>
                                <h2 class="poker-sub-title">Pridruži se novom proljetnom poker događaju! 🌸</h2>
                                
                                <p>
                                     SuperPoker ti donosi nova poker uzbuđenja. Kreće potpuno nova Cash Liga. Najbolji igrači osigurat će svoje ulaznice za main event u Bratislavi i pripremit se za nadolazeću Proljetnu Ligu koja starta nakon Cash Lige, koja traje od 23. 3 do 18. 4. 2026.
                                </p>
                                
                                <p>
                                     Zaigraj i osiguraj svoje mjesto za Bratislavi!
                                </p>
                                <div class="text-center ">
                                        <br>
                                        <a class="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href="${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperPoker_CashLiga.pdf?c=${casino.config.guiCacheVerzija}"><span>Pravila igre</span>
                                    <span class="icon ico-expand-outline"></span>
                                        </a>
                                    </div>
                                    </div>`,
                    body: <CashLiga sifra='cash-liga' />, rezultati: <BonusPobjednici sifra='cash-liga' />, active: true
                },
                {
                    sifra: 'turnir-prvaka', naziv: 'Turnir Prvaka', naziv2: 'Turnir Prvaka', bannerUrl: 'content/images/poker/bonusi/turnirprvaka.jpg',
                    opisKratki: 'Pokaži da si najbolji – kvalificiraj se sad!',
                    opis: `<div class="poker-prvenstvo-hrvatske-container">
                            <div>
                                <h2 class="poker-sub-title">Pokaži tko je pravi kralj pokera u Hrvatskoj!</h2>
                                
                                <p>
                                     Od 1. srpnja 2025. do 1. siječnja 2026. sudjeluj svakog dana u glavnom turniru i osvajaj vrijedne nagrade. Najbolji među najboljima kvalificirat će se za <b>Turnir Prvaka</b> – ekskluzivni događaj s bogatim nagradama i prestižem.
                                </p>
                                <div class="text-center ">
                                        <br>
                                        <a class="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href="https://cdn.supersport.hr/Casino/Poker/Pravila/TurnirPrvaka.pdf?v=2"><span>Pravila igre</span>
                                    <span class="icon ico-expand-outline"></span>
                                        </a>
                                    </div>
                                    </div>`,
                    body: <TurnirPrvaka sifra='prvenstvo-hrvatske' />, rezultati: null, active: true
                },
                {
                    sifra: 'flop-utrka', naziv: 'Flop utrka', naziv2: 'Flop utrka – budi najbrži', bannerUrl: 'content/images/poker/bonusi/img_bonus_flop.jpg',
                    opisKratki: 'Zaigrajte Poker Flop utrku i osvojite novčane bonuse!',
                    opis: 'Zaigrajte Poker Flop utrku i osvojite novčane bonuse!<br/><br/>Bodove osvajate tokom igre na Cash stolovima za svaki Flop koji vidite sa svoje dvije karte u ruci, a broj bodova ovisi o iznosu small i big blinda. Također, dodatne bodove skupljaš i ako si imao gubitni dan i tjedan.',
                    body: <FlopUtrkaBody sifra='flop-utrka' />, rezultati: <BonusPobjednici sifra='flop-utrka' />, active: true
                },
                {
                    sifra: 'bonus-izazovi', naziv: 'Bonus izazovi', naziv2: 'Bonus izazovi', bannerUrl: 'content/images/poker/bonusi/img_bonus_bonuses.jpg',
                    opisKratki: 'Zaigraj Poker na cash stolovima, ispuni postavljene Poker izazove i osvoji novčane bonus nagrade.',
                    opis: 'Zaigraj Poker na cash stolovima, ispuni postavljene Poker izazove i osvoji novčane bonus nagrade. Poker izazovi se mogu ispuniti samo jednom dnevno, jednom tjedno ili neograničen broj puta.<br /><br />Ispunite izazove na micro cash stolovima i osvojite velike nagrade!<br /> <br /> Bodove za ispunjavanje izazova osvajate za vrijeme trajanja bonusa i osvajate dodatne nagrade.',
                    body: <BonusIzazoviBody sifra='bonus-izazovi' />, rezultati: <BonusPobjednici sifra='bonus-izazovi' />, active: true
                },
                {
                    sifra: 'ssopl', naziv: 'SSOPL', naziv2: 'SuperSport Online Poker Liga „Nova 2022 godina“.', bannerUrl: 'content/images/poker/bonusi/img_bonus_ssopl.jpg',
                    opisKratki: 'SuperSport Online Poker Liga daje ti priliku da svaki dan zaigraš jedan od mnogobrojnih dnevnih turnira i osvojiš novčane nagrade, dok istovremeno sakupljaš bodove za sudjelovanje u završnom turniru.',
                    opis: 'SuperSport Online Poker Liga daje ti priliku da svaki dan zaigraš jedan od mnogobrojnih dnevnih turnira i osvojiš novčane nagrade, dok istovremeno sakupljaš bodove za sudjelovanje u završnom turniru.<br/><br/>SSOPL je natjecanje za sve igrače Pokera koji žele pokazati svoju vještinu, osvojiti novčane nagrade i posebne nagrade za igru na turnirima uživo u organizaciji SuperSporta. Postanite pobjednik SSOPL-a i uđite u kuću slavnih! Čeka vas titula najboljeg online igrača u Hrvatskoj i super nagrade!<br/><br/>SuperSport Online Poker Liga je na rasporedu od <b>18. prosinca 2021. do 06. siječnja 2022</b>. Natječete se za nagradni fond u iznosu od najmanje 6.636,14 €. <br/><br/>Svaki dan trajanja na rasporedu su dva SSOPL turnira, ukupno 40 turnira.<br/><br/>Nagrade se dijele na poredak i na završnom turniru.<br/><br/>U nastavku pogledajte puni raspored SSOPL turnira ili potražite najavljene turnire u Poker aplikaciji pod nazivom SSOPL!',
                    body: <SsoplBody sifra='ssopl' />, rezultati: <BonusPobjednici sifra='ssopl' />, active: false
                },
                //{
                //    sifra: 'poker-rakeback', naziv: 'Ljetni RakeBack!', naziv2: 'Ljetni RakeBack!', bannerUrl: 'content/images/poker/bonusi/img_poker_rakeback.jpg',
                //    opisKratki: 'Tijekom srpnja i kolovoza nagrađujemo sa 20 ili 30% rakebacka.',
                //    opis: 'Nagrađujemo igrače sa 20% RakeBack-a! Supersport će vam isplatiti 20% iznosa Rake-a (RakeBack) s kojim ste sudjelovali u kvalificiranim rukama.',
                //    body: <PokerRakebackBody sifra='poker-rakeback' />, rezultati: null, active: false
                //},
                {
                    sifra: 'poker-reload', naziv: 'Poker reload', naziv2: 'Poker reload – udvostruči ulog', bannerUrl: 'content/images/poker/bonusi/img_bonus_reload.jpg',
                    opisKratki: 'Aktiviraj SuperSport poker reload bonus do 100,00% iznosa uplate, zaigraj online poker, sakupljaj bodove i osvoji bonus!',
                    opis: 'Aktiviraj SuperSport poker reload bonus do 100,00% iznosa uplate, zaigraj online poker, sakupljaj bodove i osvoji bonus!<br />',
                    body: <PokerReloadBody sifra='poker-reload' />, rezultati: null, active: false
                },
            ],
        }

        this.getBackHeaderText = this.getBackHeaderText.bind(this);
        this.renderSideNavigationItem = this.renderSideNavigationItem.bind(this);
        this.renderBonusDetails = this.renderBonusDetails.bind(this);
        this.renderBonusi = this.renderBonusi.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Svi bonusi', 'poker', this.props.user);
    }

    componentDidUpdate(prevProps) {
        // Check if the URL has changed
        if (prevProps.route.location.pathname !== this.props.route.location.pathname) {
            window.scrollTo(0, 0); // Scroll to the top of the page
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    getBackHeaderText(route) {
        var sifra = route.match.params.bonus || '';
        var action = route.match.params.action || 'info';
        return this.state.bonusi.filter(x => x.sifra == sifra)[0].naziv + ' - ' + (action == 'info' ? 'Informacije' : 'Rezultati');
    }

    renderSideNavigationItem(bonus) {
        var pathName = this.props.route.match.url;
        return <NavLink key={bonus.sifra} activeClassName="selected" className="sidebar-menu--link"
            to={(pathName + '/' + bonus.sifra).split('//').join('/')}><span>{bonus.naziv}</span></NavLink>
    }

    renderBonusDetails(route) {
        var sifra = route.match.params.bonus;
        var action = route.match.params.action || 'info';
        var bonus = this.state && this.state.bonusi && this.state.bonusi.filter(x => x.sifra == sifra)[0];

        return <div className="turnir turnir-details">
            <div className="relative">
                <img className="full-wide tablet-hidden  margin-top-minus-3" src={bonus.bannerUrl} alt={bonus.naziv} />
                <img className="mobile-hidden" src={bonus.bannerUrl} alt={bonus.naziv} />
                <div className="transparent-background-transparent-white-vertical tablet-hidden img-maska"></div>
            </div>

            <div>
                <div className="margin-bottom-xsmall"></div>

                {action === 'info' &&
                    <div className="padding-sides-medium-2">
                        <h1 className="v2">{bonus.naziv2}</h1>
                        <span dangerouslySetInnerHTML={{ __html: bonus.opis }} ></span>
                        <div ><br /></div>
                        <div className="tablet-hidden break-page"></div>
                    </div>
                }

                {action === 'info' && React.cloneElement(bonus.body, this.props)}
                {action !== 'info' && <div className="margin-top-small">{React.cloneElement(bonus.rezultati, this.props)}</div>}

                <div className="tablet-hidden"><br /></div>

                {action === 'info' &&
                    <div className="tablet-hidden break-page"></div>
                }
                <div className="mobile-hidden"><br /></div>
            </div>
        </div>
    }

    renderBonusi() {
        var pathName = this.props.route.match.url;
        let firstDone = false;

        return <div><h1 className="margin-bottom mobile-hidden">Sve promocije</h1>
            <div className="padding-sides-medium-2">

                {this.state && this.state.bonusi && this.state.bonusi.map((bonus) => (<div className="turnir as-block" key={bonus.sifra}>
                    {firstDone && <div className="tablet-hidden break-page"></div>}
                    {firstDone = true}
                    <div className="margin-bottom-xsmall"></div>
                    <NavLink key={bonus.sifra + 'rezultati-link'} to={pathName + '/' + bonus.sifra + '/info'} >
                        <h2 className="v2">{bonus.naziv2}</h2>
                        <div className="relative">
                            <img src={bonus.bannerUrl} alt={bonus.naziv} />
                            {!bonus.active && <div className='soon-badge' />}
                        </div>
                    </NavLink>
                    <div className="margin-bottom-xsmall"></div>
                    <span>{bonus.opisKratki}</span>
                    <div className="flex  margin-bottom-small margin-top-xsmall">
                        {bonus.rezultati && <NavLink className="flex-expand-1 btn medium fill dark-green " key={bonus.sifra + 'rezultati-link'} to={pathName + '/' + bonus.sifra + '/results'}><span>Rezultati</span></NavLink>}
                        {bonus.rezultati && <div>&nbsp;&nbsp;</div>}
                        <NavLink className="flex-expand-1 btn medium fill gray " key={bonus.sifra + 'info-link'} to={pathName + '/' + bonus.sifra + '/info'}><span>Saznaj više</span></NavLink>
                    </div>
                    <div className="mobile-hidden"><br /></div>
                </div>))}
                <div className="tablet-hidden break-page"></div>
            </div>
        </div>
    }

    render() {
        var pathName = this.props.route.match.url;
        return (
            <div>
                <Switch>
                    {/* bonus header */}
                    <Route path={"/poker/promotions/:bonus/:action?"} render={(route) =>
                    (<div>
                        <Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText={this.getBackHeaderText(route)} headerBackUrl={'/poker/promotions'}></Header>
                    </div>)} />

                    {/* bonus header, default */}
                    <Route render={(route) =>
                        <Header key="header" {...this.state} {...this.props} ></Header>} />

                </Switch>

                <div className="flex margin-1p-on-tablet">
                    {/* meni lijevi za tablet */}
                    <div className="account-menu mobile-hidden">
                        <div className="as-block">
                            <div className="sidebar-menu">
                                <span className="sidebar-menu--header">Popis promocija</span>
                                <NavLink key='svi-bonusi' exact activeClassName="selected" className="sidebar-menu--link" to={pathName}><span>Sve promocije</span><span className='icon ico-eye'></span></NavLink>
                                {this.state.bonusi.map(this.renderSideNavigationItem)}
                            </div>
                        </div>
                    </div>
                    <div id="page-wrapper" className="white flex-expand-1 no-padding-on-mobile border-on-tablet no-z-index">
                        <div className="max-width-75">
                            <Switch>
                                {/* bonus header */}
                                <Route path={"/poker/promotions/:bonus/:action?"}
                                    render={(route) => this.renderBonusDetails(route)} />
                                {/* bonusi  header, default */}
                                <Route render={this.renderBonusi} />
                            </Switch>
                        </div>
                    </div>
                </div>
                <ObavijestiPoker {...this.props}></ObavijestiPoker>
            </div>
        )
    }
};